<template>
  <div class="prizes-swiper">
    <Swiper
      :modules="__swiperConfiguration.modules"
      :loop="__swiperConfiguration.loop"
      :grab-cursor="__swiperConfiguration.grapCursor"
      :centered-slides="__swiperConfiguration.centeredSlides"
      :slides-per-view="__swiperConfiguration.slidesPerView"
      :space-between="__swiperConfiguration.spaceBetween"
      :navigation="__swiperConfiguration.navigation"
      :enabled="__swiperConfiguration.enabled"
      @swiper="handleSwiperInit"
      @slideChangeTransitionEnd="handleSlideChange"
    >
      <SwiperSlide
        v-for="prize in prizeList"
        :key="prize.type"
      >
        <div class="carousel-item">
          <div class="img_placeholder">
            <BaseImage :src="prize.imgUrl" :alt="'Prize ' + prize.type" />
          </div>

          <h4>
            {{ $_translations.value[`select_prize_item_title_${ prize.type }`] }}
          </h4>

          <p>{{ prize.description }}</p>
        </div>
      </SwiperSlide>
    </Swiper>

    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Navigation } from 'swiper/modules';
import BaseImage from '@/components/image/BaseImage.vue';

const swiperConfiguration = {
  modules: [Navigation],
  loop: true,
  grapCursor: true,
  enabled: true,
  centeredSlides: false,
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: { nextEl: '.swiper-button-next', prevEl: '.swiper-button-prev' },
};

const emits = defineEmits(['update:modelValue']);

const props = defineProps({
  modelValue: {
    type: String,
    default: '',
  },
  prizeList: {
    type: Array,
    default: () => [],
  },
});

const __swiperConfiguration = computed(() => {
  const hasMultipleItems = props.prizeList.length > 1;

  return {
    ...swiperConfiguration,
    loop: hasMultipleItems,
    enabled: hasMultipleItems,
    grapCursor: hasMultipleItems,
  };
});

const handleSwiperInit = (swiper) => {
  const findIndex = props.prizeList.findIndex(({ type }) => type === props.modelValue);

  if (findIndex > -1) {
    swiper.slideToLoop(findIndex, 0, false);
  }
};

const handleSlideChange = (swiper) => {
  const type = props.prizeList.find((_e, index) => index === swiper.realIndex)?.type;

  if (type) {
    emits('update:modelValue', type);
  }
};
</script>
